import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.min.css";

const OrdersList = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [dateRange, setDateRange] = useState({ from: "", to: "" });

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await axios.get("https://sonvika.hxbindia.com/api/orders");
        if (res.data.success) {
          setOrders(res.data.orders);
          setFilteredOrders(res.data.orders);
        }
      } catch (err) {
        console.error("Error fetching orders:", err);
      }
    };
    fetchOrders();
  }, []);

  useEffect(() => {
    filterOrders();
  }, [searchTerm, statusFilter, dateRange, orders]);

  const filterOrders = () => {
    let filtered = [...orders];

    // 🔍 Search by name, email, address, or contact
    if (searchTerm.trim()) {
      filtered = filtered.filter((order) =>
        [order.name, order.email, order.address, order.contactNumber]
          .some((field) =>
            field?.toLowerCase().includes(searchTerm.toLowerCase())
          )
      );
    }

    // 📦 Filter by payment status
    if (statusFilter) {
      filtered = filtered.filter(
        (order) => order.paymentStatus === statusFilter
      );
    }

    // 📅 Filter by date range
    if (dateRange.from && dateRange.to) {
      filtered = filtered.filter((order) => {
        const orderDate = moment(order.createdAt);
        return (
          orderDate.isSameOrAfter(moment(dateRange.from)) &&
          orderDate.isSameOrBefore(moment(dateRange.to))
        );
      });
    }

    setFilteredOrders(filtered);
  };

  const handleStatusChange = async (orderId, newStatus) => {
    try {
      await axios.put(`https://sonvika.hxbindia.com/api/orders/${orderId}`, {
        paymentStatus: newStatus,
      });

      const updated = orders.map((order) =>
        order._id === orderId
          ? { ...order, paymentStatus: newStatus }
          : order
      );
      setOrders(updated);
      setFilteredOrders(updated);
    } catch (err) {
      console.error("Failed to update status:", err);
      alert("Failed to update order status");
    }
  };

  return (
    <div className="container py-5">
      <h2 className="mb-4">🧾 Admin - Orders List</h2>

      {/* Filters */}
      <div className="row mb-4 g-3">
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            placeholder="Search by name, email, or address"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="col-md-3">
          <select
            className="form-select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="">All Status</option>
            <option value="Pending">Pending</option>
            <option value="Paid">Paid</option>
            <option value="Failed">Failed</option>
          </select>
        </div>

        <div className="col-md-2">
          <input
            type="date"
            className="form-control"
            value={dateRange.from}
            onChange={(e) =>
              setDateRange({ ...dateRange, from: e.target.value })
            }
          />
        </div>

        <div className="col-md-2">
          <input
            type="date"
            className="form-control"
            value={dateRange.to}
            onChange={(e) =>
              setDateRange({ ...dateRange, to: e.target.value })
            }
          />
        </div>

        <div className="col-md-1">
          <button
            className="btn btn-secondary w-100"
            onClick={() => {
              setSearchTerm("");
              setStatusFilter("");
              setDateRange({ from: "", to: "" });
            }}
          >
            Reset
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Customer</th>
              <th>Email</th>
              <th>Contact</th>
              <th>Address</th>
              <th>Product</th>
              <th>Amount</th>
              <th>Payment Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {filteredOrders.length === 0 ? (
              <tr>
                <td colSpan="9" className="text-center py-4">
                  No orders found
                </td>
              </tr>
            ) : (
              filteredOrders.map((order, idx) => (
                <tr key={order._id}>
                  <td>{idx + 1}</td>
                  <td>{order.name}</td>
                  <td>{order.email}</td>
                  <td>{order.contactNumber}</td>
                  <td>{order.address}</td>
                  <td>{order.productId?.name || "N/A"}</td>
                  <td>₹{order.totalAmount}</td>
                  <td>
                    <select
                      className={`form-select form-select-sm ${
                        order.paymentStatus === "Paid"
                          ? "bg-success text-white"
                          : order.paymentStatus === "Failed"
                          ? "bg-danger text-white"
                          : "bg-warning text-dark"
                      }`}
                      value={order.paymentStatus}
                      onChange={(e) =>
                        handleStatusChange(order._id, e.target.value)
                      }
                    >
                      <option value="Pending">Pending</option>
                      <option value="Paid">Paid</option>
                      <option value="Failed">Failed</option>
                    </select>
                  </td>
                  <td>{moment(order.createdAt).format("DD MMM YYYY, hh:mm A")}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OrdersList;
